import React, { useCallback, useEffect, useState } from "react";
import {
  CrossWrapper,
  Input,
  SearchBoxContainer,
  SearchIcon,
} from "./index.styled";
import { ReactComponent as Search } from "../../Assets/Icons/CategorySearch.svg";
import { transformDataForFrontend } from "../HospitalComparisonTable/dataHandler";
import { ReactComponent as CrossSolid } from "../../Assets/Icons/CrossSolid.svg";

const CategoriesSearchBox = ({
  placeholder = "Search...",
  onSearch,
  searchParams,
  hospitalsData,
}) => {
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(
    searchParams.searchTerm,
  );

  useEffect(() => {
    const handler = setTimeout(() => {
      searchParams.setSearchTerm(debouncedSearchTerm);
      handleSearch(debouncedSearchTerm);
    }, 300);

    return () => clearTimeout(handler);
  }, [debouncedSearchTerm]);

  const {
    hospitals,
    facilities,
    financials,
    affiliations,
    accreditations,
    oncology_focus,
    // oncology_research,
    accessibility_inclusivity,
    quality_of_care,
    // patient_experience,
  } = transformDataForFrontend(hospitalsData);

  const handleSearch = useCallback(
    (searchTerm) => {
      if (!searchTerm.trim()) {
        searchParams.setSearchResults([]);
        searchParams.setIsSearchOpen(false);
        return;
      }

      const searchSections = {
        facilities,
        financials,
        affiliations,
        accreditations,
        oncology_focus,
        // oncology_research,
        accessibility_inclusivity,
        quality_of_care,
        // patient_experience,
      };

      const results = Object.entries(searchSections ?? {}).flatMap(
        ([sectionKey, sectionData]) =>
          sectionData.flatMap(({ label, values, id }) => {
            const lowerSearchTerm = searchTerm?.toLowerCase();
            const isLabelMatch = label?.toLowerCase().includes(lowerSearchTerm);
            const isValueMatch = values?.some((value) =>
              value?.toString().toLowerCase().includes(lowerSearchTerm),
            );

            if (isLabelMatch || isValueMatch) {
              return {
                section: sectionKey,
                label,
                values,
                id,
              };
            }
            return [];
          }) ?? [],
      );

      searchParams.setSearchResults(results);
      searchParams.setIsSearchOpen(true);
    },
    [
      facilities,
      financials,
      affiliations,
      accreditations,
      oncology_focus,
      // oncology_research,
      accessibility_inclusivity,
      quality_of_care,
      // patient_experience,
      searchParams,
    ],
  );

  const handleClear = () => {
    setDebouncedSearchTerm("");
    searchParams.setIsSearchOpen(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === "ArrowDown") {
      e.preventDefault();
      e.target.blur();
      document.dispatchEvent(
        new KeyboardEvent("keydown", { key: "ArrowDown" }),
      );
    }
  };

  return (
    <SearchBoxContainer>
      <Input
        id="search-input"
        type="text"
        placeholder={placeholder}
        value={debouncedSearchTerm}
        autoComplete="off"
        autoCorrect="off"
        autoCapitalize="off"
        spellCheck="false"
        onChange={(e) => setDebouncedSearchTerm(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            handleSearch(debouncedSearchTerm);
          } else {
            handleKeyDown(e);
          }
        }}
      />
      <SearchIcon onClick={() => handleSearch(debouncedSearchTerm)}>
        <Search />
      </SearchIcon>
      {debouncedSearchTerm && (
        <CrossWrapper onClick={() => handleClear()}>
          <CrossSolid />
        </CrossWrapper>
      )}
    </SearchBoxContainer>
  );
};

export default CategoriesSearchBox;
